import React from 'react';
import './Class.css';
import class10 from '../../Images/Class-10.png';
import {Helmet} from "react-helmet";
const Class10 = () => (
  <div className="explore-container">
    <Helmet>
                <meta charSet="utf-8" />
                <title>Dasvi ke Dangal - Otter Tutor</title>
                <link rel="canonical" href="http://ottertutors.com" />
            </Helmet>
    {/* Back Button */}
    <button className="back-button" onClick={() => window.history.back()}>
      ← Back
    </button>
    {/* Lakshya Card (Right Side, Above Header) */}
    <div className="lakshya-card">
      <img
        src={class10}
        loading="lazy"
        alt="Lakshya NEET 3.0"
        className="lakshya-image"
      />
      <div className="course-details">
  <p className="pricing">💳 Monthly Fees: ₹ 1499/-</p>
  <p className="pricing">💼 Fees Billed Till Exams: ₹ 7499/-</p>
  <a href="https://rzp.io/rzp/dasvikedangal" target="_blank" rel="noopener noreferrer">
    <button className="buy-button">Buy Now</button>
  </a>
</div>

    </div>

    {/* Lakshya Header (Full Width) */}
    <div className="lakshya-header">
      <div className="lakshya-header-content">
        <h2 className="lakshya-title">Dasvi ke <span className='highlight'>Dangal</span>(Class-<span className='highlight'>10</span>)</h2>
        
      </div>
    </div>

     {/* Batch Details Section */}
 <div className="batch-details">
      <h3>Description</h3>
      <ul>
  <li><strong>1️⃣Focused Learning with Small Batches</strong>  
    <ul>
      <li>🌱 Only 10 students per batch for quality attention and better results.</li>
    </ul>
  </li>
  <li><strong>2️⃣Subjects for Class 10 to Conquer</strong>  
    <ul>
      🧮 Mathematics
      🔬 Science
      📖 English
      🌍 Social Science (SST)
      ✍️ Hindi
    </ul>
  </li>
  <li><strong>3️⃣Structured Daily Classes</strong>  
    <ul>
      <li>🕒 Two engaging 1-hour sessions daily to ensure focused learning.</li>
    </ul>
  </li>
  <li><strong>4️⃣24/7 Doubt-Solving</strong>  
    <ul>
      <li>🩵 We're always here—get instant help for any doubts, anytime!</li>
    </ul>
  </li>
  <li><strong>5️⃣Interactive Live Sessions</strong>  
    <ul>
      <li>👩‍🏫 Learn directly from expert tutors with interactive and engaging classes.</li>
    </ul>
  </li>
  <li><strong>6️⃣Study Materials for Success</strong>  
    <ul>
      <li>📝 Access class notes, practice sheets, and recorded lectures for revision.</li>
    </ul>
  </li>
  <li><strong>7️⃣Fun & Rewarding Quizzes</strong>  
    <ul>
      <li>🏆 Participate in live quizzes and win exciting prizes and badges!</li>
    </ul>
  </li>
  <li><strong>8️⃣Parent Engagement</strong>  
    <ul>
      <li>📊 Weekly Parent-Teacher Meetings and detailed progress reports.</li>
    </ul>
  </li>
  <li><strong>9️⃣Weekly Tests for Continuous Improvement</strong>  
    <ul>
      <li>✍️ Regular assessments to track your progress and ensure you're always on track.</li>
    </ul>
  </li>
  <li><strong>🌈 What Makes Us Special?</strong>  
    <ul>
      <li>💻 Enjoy a FREE Coding Course to develop essential future skills.</li>
    </ul>
  </li>
  <li><strong>📩 Got Questions?</strong>  
    <ul>
      <li>Email us at <a href="mailto:support@ottertutors.com">support@ottertutors.com</a></li>
    </ul>
  </li>
  <br/>
  <li><strong>🚀 Join <span className='highlight1'>‘Dasvi Ke Dangal’</span> Take your Class 10 journey to the next level with expert guidance, care, and support! 🚀</strong>  
    
  </li>
</ul>


    </div>

    {/* FAQ Section */}
    <div className="faq-section">
      <h2>FAQs</h2>
      <p style={{ textAlign: 'center' }}>
  Here are some of the frequently asked questions:
</p>
      <div className="faq-grid">
        <div className="faq-item">
        🎯
          <div>
            <h3>Who Should Join "Dasvi Ke Dangal"?</h3>
            <p>
            🎓 This batch is designed for Class 10 students who are ready to tackle board exams and excel!
            </p>
          </div>
        </div>
        <div className="faq-item">
        🎯
          <div>
            <h3>Where Are the Classes Held?</h3>
            <p>💻 Classes are conducted via Zoom, and you’ll receive links through WhatsApp groups.</p>
          </div>
        </div>
        <div className="faq-item">
        🎯
          <div>
            <h3>How Can I Get Help If I Have Doubts?</h3>
            <p> 💬 Our 24/7 doubt-solving support ensures you're never left with unanswered questions!</p>
          </div>
        </div>
        <div className="faq-item">
        🎯
          <div>
            <h3>What Happens If I Miss a Class?</h3>
            <p>
            📼 Don’t worry! You’ll have access to recorded lectures for any missed sessions.
            </p>
          </div>
        </div>
        <div className="faq-item">
        🎯
          <div>
            <h3>Are the Tests and Quizzes Mandatory?</h3>
            <p>
            ✅ Yes! Weekly tests and live quizzes help you track progress and stay engaged.
            </p>
          </div>
        </div>
        <div className="faq-item">
        🎯
          <div>
            <h3>Can I Get a Refund After Batch Purchase?
            </h3>
            <p>
            💡 No refund will be provided after batch purchase. We have already invested heavily in offering the best learning experience for our students, including tech infrastructure, employee salaries, and more. Please make an informed decision before purchasing a batch.

            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Class10;
